<script setup lang="ts">
import { Search } from 'lucide-vue-next';
import { ref } from 'vue';

import type { PartnerCampaignFilterOption, PartnerViewFilters } from '../types';

defineProps<{
  campaignOptions: PartnerCampaignFilterOption[];
}>();

const emit = defineEmits<{
  apply: [filters: PartnerViewFilters];
  clear: [];
}>();

const searchInput = ref('');
const campaignInput = ref('');

function apply() {
  emit('apply', {
    campaignId: campaignInput.value,
    search: searchInput.value,
  });
}

function clear() {
  searchInput.value = '';
  campaignInput.value = '';
  emit('clear');
}
</script>

<template>
  <div class="col-12">
    <div class="filter-bar">
      <div class="filter-group filter-group-search">
        <label class="filter-label" for="partner-search">Buscar</label>
        <input
          id="partner-search"
          v-model="searchInput"
          type="text"
          class="filter-input"
          placeholder="ID do parceiro, CNPJ ou nome da campanha…"
          @keydown.enter="apply"
        />
      </div>

      <div class="filter-group">
        <label class="filter-label" for="partner-campaign">Filtrar campanha</label>
        <select id="partner-campaign" v-model="campaignInput" class="filter-input">
          <option value="">Todas</option>
          <option
            v-for="option in campaignOptions"
            :key="option.id"
            :value="option.id"
          >
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-actions">
        <button type="button" class="btn-sol btn-secondary" @click="clear">
          Limpar
        </button>
        <button type="button" class="btn-sol btn-primary" @click="apply">
          <Search class="icon icon-sm" />
          Buscar
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.filter-bar {
  display: grid;
  grid-template-columns: 1fr 280px auto;
  gap: 12px;
  align-items: end;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #E4E6EB;
  border-radius: 12px;
  margin-bottom: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;

    .filter-actions {
      grid-column: 1;
    }
  }
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-label {
  font-size: 11px;
  color: #6B7280;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.filter-input {
  padding: 8px 10px;
  border: 1px solid #E4E6EB;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
  color: #222;
  font-family: inherit;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #00B569;
  }
}

.filter-actions {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.btn-sol {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;

  &.btn-primary {
    background: #00B569;
    color: #fff;

    &:hover { background: #009957; }
  }

  &.btn-secondary {
    background: #fff;
    color: #222;
    border-color: #E4E6EB;

    &:hover { background: #F5F6F8; }
  }
}
</style>
